// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import LOGINPAGE_CONSTANTS from '../LoginPage.constants';

const initialState = fromJS({
  error: null,
  loginModalMountedState: false,
  checkoutModalMountedState: false,
  loginErrorMessage: null,
  componentType: LOGINPAGE_CONSTANTS.PAGE_TYPE.LOGIN,
  isLoading: false,
  isAccountCardVisible: true,
  emailRetry: -1,
  emailAddressFromSS: null,
  existingUserResponse: null,
  isPlccLoginLoading: false,
  showEmailScreen: true,
  phoneCountryCode: null,
});

// eslint-disable-next-line complexity
const LoginPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGINPAGE_CONSTANTS.LOGIN:
      return state.set('error', null);
    case LOGINPAGE_CONSTANTS.SET_LOGIN_LOADING_STATE:
      return state.set('isLoading', action.payload.isLoading);
    case LOGINPAGE_CONSTANTS.SET_PLCC_LOGIN_LOADING_STATE:
      return state.set('isPlccLoginLoading', action.payload);
    case LOGINPAGE_CONSTANTS.SET_LOGIN_INFO:
      return state.set('error', fromJS(action.payload));
    case LOGINPAGE_CONSTANTS.SET_COUNTRY_CODE:
      return state.set('phoneCountryCode', action.payload);
    case LOGINPAGE_CONSTANTS.RESET_LOGIN_INFO:
      return state.set('error', null);
    case LOGINPAGE_CONSTANTS.LOGIN_MODAL_MOUNTED_STATE:
      return state
        .set('loginModalMountedState', action.payload.state)
        .set('isAccountCardVisible', action.payload.isAccountCardVisible);
    case LOGINPAGE_CONSTANTS.CHECKOUT_MODAL_MOUNTED_STATE:
      return state
        .set('checkoutModalMountedState', action.payload.state)
        .set(
          'componentType',
          action.payload.state
            ? action.payload.componentType || LOGINPAGE_CONSTANTS.PAGE_TYPE.LOGIN
            : LOGINPAGE_CONSTANTS.PAGE_TYPE.LOGIN
        );
    case LOGINPAGE_CONSTANTS.SET_EMAIL_RETRY_COUNT:
      return state.set('emailRetry', action.payload);
    case LOGINPAGE_CONSTANTS.SET_EXISTING_USER_RESPONSE:
      return state.set('existingUserResponse', action.payload);
    case LOGINPAGE_CONSTANTS.MASKED_PHONE_NUMBER:
      return state.set('maskedPhoneNumber', action.payload);
    case LOGINPAGE_CONSTANTS.SHOW_PHONE_LOGIN_OPTION:
      return state.set('isShowPhoneLoginOption', action.payload);
    case LOGINPAGE_CONSTANTS.SHOW_OTP_INPUT_SCREEN:
      return state.set('isShowOTPInputScreen', action.payload);
    case LOGINPAGE_CONSTANTS.OTP_TOKEN:
      return state.set('otpToken', action.payload);
    case LOGINPAGE_CONSTANTS.USER_NOT_EXIST:
      return state.set('userNotExist', action.payload);
    case LOGINPAGE_CONSTANTS.LOGIN_SELECTION_OPTION:
      return state.set('loginSelectionOption', action.payload);
    case LOGINPAGE_CONSTANTS.IS_OTP_LIMIT:
      return state.set('isOtpLimit', action.payload);
    case LOGINPAGE_CONSTANTS.SHOW_EMAIL_FORM_SCREEN:
      return state.set('showEmailScreen', action.payload);
    case LOGINPAGE_CONSTANTS.IS_LOCKED:
      return state.set('isLocked', action.payload);

    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default LoginPageReducer;
